import React from "react";
import ReactApexChart from "react-apexcharts";
import { IReportMetricsTotal } from "../../../../../@types/reports-metrics.type";
import styles from "./styles.module.scss";

export const CircleChart: React.FC<IReportMetricsTotal> = ({
  totalBillable,
  totalBillablePercentage,
  totalNonBillable,
  totalNonBillablePercentage,
}) => {
  const series = [totalBillablePercentage, totalNonBillablePercentage];
  const labels = ["Faturável", "Não Faturável"];
  const options = {
    colors: ["#2bf49d", "#c7c7c7"],
    chart: {
      type: "donut",
      fontFamily: "archivo, sans-serif",
      width: "100%",
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: "100%",
            height: 300,
          },
          legend: {
            position: "left",
          },
        },
      },
    ],
    legend: {
      show: true,
      position: "left",
      horizontalAlign: "left",
      fontSize: "13px",
      labels: {
        colors: ["#616161", "#616161"],
      },
      formatter: function (val, { seriesIndex }) {
        return `${val} (${
          seriesIndex == 0 ? `${totalBillable}` : `${totalNonBillable}`
        })`;
      },
    },
    dataLabels: {
      formatter: function (val) {
        return Math.round(val).toString().replace(".", ",") + "%";
      },
      dropShadow: {
        enabled: true,
        top: 0,
        left: 0,
        blur: 0,
        opacity: 0.5,
      },
      style: {
        colors: ["#212121"],
      },
    },
    tooltip: {
      custom: function ({ series, seriesIndex }) {
        const value = series[seriesIndex];
        const label = labels[seriesIndex];

        return `
          <div class='labelCustom' style="flex-direction: row;">
            <strong>${label}:</strong>
            <span>${value.toString().replace(".", ",")}%</span>
          </div>
        `;
      },
    },
    title: {
      text: "Faturável X Não Faturável",
      style: {
        color: `#212121`,
        fontWeight: 600,
      },
    },
    labels,
  };

  return (
    <div className={styles.mainCard}>
      <div id="chart">
        <ReactApexChart
          options={options}
          series={series}
          type="donut"
          height="250"
          width="100%"
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};
